import { Position } from '../models/position.interface';

import { ApiCoordinates } from '@api/_api/api-geolocation/models/api-coordinates.model';
import { Coordinates } from '@api/geolocation/models/coordinates.model';
import { Geolocation } from '@api/geolocation/models/geolocation.model';

/**
 * Transformer para modelar datos obtenidos por la API al modelo Coordinates
 */

// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class GeolocationTransformer {
    /**
     * Transforma coordenadas obtenidas desde Google Geocode Service al modelo de la aplicación
     * @param apiCoordinates Coordenadas obtenidas desde Google Geocode Service
     * @returns Objeto de tipo "Geolocation" transformado a partir del modelo "ApiGoogleGeocode"
     */
    public static coordinatesFromGoogleGeocodeService(apiCoordinates): Geolocation {
        const coordinates: Geolocation = {
            latitude: apiCoordinates.geometry.location.lat().toString(),
            longitude: apiCoordinates.geometry.location.lng().toString(),
        };

        const postalCode = GeolocationTransformer.extractFromAdress(apiCoordinates.address_components, 'postal_code');
        if (postalCode) {
            coordinates.postalCode = postalCode;
        }

        const locality = GeolocationTransformer.extractFromAdress(apiCoordinates.address_components, 'locality');
        if (locality) {
            coordinates.locality = locality;
        }

        const country = GeolocationTransformer.extractFromAdress(apiCoordinates.address_components, 'country');
        if (country) {
            coordinates.country = country;
        }

        return coordinates;
    }

    public static coordinatesFromBaiduService(apiCoordinates) {
        const coordinates: Geolocation = {
            latitude: apiCoordinates.lat.toString(),
            longitude: apiCoordinates.lng.toString(),
        };

        return coordinates;
    }

    public static coordinatesService(apiCoordinates: ApiCoordinates): Coordinates {
        const coordinates: Coordinates = {
            latitude: apiCoordinates.lat.toString(),
            longitude: apiCoordinates.long.toString(),
            countryCode: apiCoordinates.country_code,
        };

        return coordinates;
    }

    /**
     * Transforma coordenadas obtenidas desde el navegador al modelo de la aplicación
     * @param positionCoordinates Coordenadas obtenidas desde el navegador
     * @returns Objeto de tipo "Coordinates" transformado a partir del modelo "Position"
     */
    public static coordinatesFromGeoPosition(positionCoordinates: Position) {
        const coordinates: Coordinates = {
            latitude: positionCoordinates.coords.latitude.toString(),
            longitude: positionCoordinates.coords.longitude.toString(),
        };

        return coordinates;
    }

    private static extractFromAdress(components, type): string {
        for (const component of components) {
            for (const componentType of component.types) {
                if (componentType === type) {
                    return component.long_name;
                }
            }
        }
    }

    public static countryCodeFromGeocoderResponse(geocoderResponse) {
        const canariasAreaLevel = 'CN';
        if (geocoderResponse.address_components.find((addressComponent) => {
            return addressComponent.types.find((type)=> type === 'administrative_area_level_1');
        })?.short_name === canariasAreaLevel) {
            return 'IC';
        }
        return geocoderResponse.address_components.find((addressComponent) => {
            return addressComponent.types.find((type)=> type === 'country');
        })?.short_name;
    }
}
